import { Aprendizado } from "./style";
import Foto from "../../../../assets/foto-flavio.webp";

function AprendizadoComponent() {
  return (
    <Aprendizado id="quemsou">
      <div id="pather-div">
        <section id="sec-img">
          <figure>
            <img src={Foto} alt="" />
          </figure>
        </section>
        <section id="sec-txt">
          <span>aprendizado exclusivo!</span>
          <h1>Eu vou estar com você por todo esse caminho..</h1>
          <p>
            Um profissional engajado, que facilitou a comunicação em inglês a
            mais de 10.000 pessoas em centenas de empresas nacionais e
            multinacionais em São Paulo e Grande São Paulo. E, nos últimos 16
            anos trabalhando com empresas de todos os portes da região do Alto
            Tietê e Vale do Paraíba. Professor por aptidão, apaixonado pelo que
            faz, com 40 anos de experiência e um propósito de vida em prol da
            educação. Com sua Consultoria de Idiomas reconhecida pela Cambridge
            University Press como parceiro da educação. Tradutor e Intérprete
            por formação e talentos desenvolvidos e aprimorados nos 28 anos de
            serviços prestados. Um estudioso entusiasmado pelo comportamento
            humano e neurociência, trazendo toda uma nova visão sobre o
            aprendizado de idiomas. Um consultor em Análise Comportamental por
            decorrência dos aprendizados e aplicações do conhecimento adquirido.
            Com o propósito de tornar o inglês uma língua popular, buscou o novo
            de maneira bem simples, estudando, criando, aplicando e ajustando,
            até chegar a um modelo comportamental a ser aplicado ao método de
            aprendizado.
          </p>
        </section>
      </div>
    </Aprendizado>
  );
}

export default AprendizadoComponent;
